import moment from "moment";
import { DOCTOR_COMMISSION_TAB } from "../../framework/tab/tabUtilsConstants";
export const newDoctorCommissionProgram = {
  min: 0,
  max: 0,
  commissionPercentage: 0,
};
export const initial_state_doctor_commission = {
  type: DOCTOR_COMMISSION_TAB,
  label: "Doctor Commission",
  actors: {
    name: "",
    start: moment().format("DD/MM/YYYY"),
    end: moment().format("DD/MM/YYYY"),
    doctorCommissionId: undefined,
    branch: [],
    manufacturerGroup: null,
    medicineForm: [],
    doctorType: null,
    manufacturerGroupOptions: [],
    allBranches: [],
  },
  doctorCommissionProgramRowData: [newDoctorCommissionProgram],
  gridColumns: null,
};
export const doctorCommissionProgramColDef = [
  { headerName: "Minimum Amount (₹)", field: "min" },
  { headerName: "Maximum Amount (₹)", field: "max" },
  { headerName: "Commission (%)", field: "commissionPercentage" },
];
